@if ((searchError | async) === null || (searchError | async)?.orderNumberItemsChecked === false) {
    <ng-container *oscNgUse="searchResult | async as result">
        <ng-container *oscNgUse="orderItems | async as orderNumberResult">
            <ng-container
                *ngTemplateOutlet="
                    result && orderNumberResult ? tabBar : orderNumberResult ? orderNumberTable : partTable;
                    context: { result, orderNumberResult }
                "
            ></ng-container>
        </ng-container>
    </ng-container>
}

<ng-template #tabBar let-result="result" let-orderNumberResult="orderNumberResult">
    <sew-notification-stack>
        <sew-notification
            type="info"
            [headline]="'SPARE_PARTS.TAB.MATERIAL_ORDER_NOTIFICATION_TEXT' | translate"
        ></sew-notification>
    </sew-notification-stack>
    <sew-tab-bar hierarchy="sub">
        <sew-tab-bar-item [name]="'SPARE_PARTS_LIST.TAB.MATERIAL' | translate" selected="true">
            <ng-container *ngTemplateOutlet="partTable; context: { result }"></ng-container>
        </sew-tab-bar-item>
        <sew-tab-bar-item [name]="'SPARE_PARTS_LIST.TAB.ORDER' | translate">
            <ng-container *ngTemplateOutlet="orderNumberTable; context: { orderNumberResult }"></ng-container>
        </sew-tab-bar-item>
    </sew-tab-bar>
</ng-template>

<ng-template #partTable let-result="result">
    <ecs-part-table
        *oscLoggedIn="let isUserLoggedIn = loggedIn; let isUserEmployee = employee"
        [searchTerm]="(searchterm | async)?.join(',')"
        [items]="result ?? null"
        [userStatus]="{ isUserLoggedIn, isUserEmployee }"
        [showPartGroupHeaderAsSkeleton]="false"
    ></ecs-part-table>
</ng-template>

<ng-template #orderNumberTable let-orderNumberResult="orderNumberResult">
    <ecs-order-number-table
        [orderNumber]="(searchterm | async)?.join(',')"
        [items]="orderNumberResult"
    ></ecs-order-number-table>
</ng-template>
